"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styleModule = _interopRequireDefault(require("./style.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable react/button-has-type */


var Button = function Button(props) {
  var className = props.className,
      id = props.id,
      type = props.type,
      onClick = props.onClick,
      text = props.text,
      block = props.block,
      primary = props.primary,
      isLoading = props.isLoading,
      disabled = props.disabled;
  return _react.default.createElement("button", {
    type: type,
    className: "".concat(_styleModule.default.button, " ").concat(block ? _styleModule.default.block : "", " ").concat(primary ? _styleModule.default.primary : "", " ").concat(className || ""),
    onClick: onClick,
    id: id,
    disabled: isLoading || disabled
  }, isLoading ? _react.default.createElement(Loader, {
    color: primary ? "#fff" : "#dfdfdf"
  }) : text);
};

var Loader = function Loader(_ref) {
  var size = _ref.size,
      color = _ref.color;
  var customize = {};

  if (size) {
    customize.height = size;
    customize.width = size;
  }

  if (color) {
    customize.borderColor = color;
    customize.borderRightColor = "transparent";
  }

  return _react.default.createElement("div", {
    className: _styleModule.default.buttonLoader,
    style: customize
  });
};

Button.defaultProps = {
  type: "button",
  id: "",
  className: "",
  onClick: function onClick() {},
  isLoading: false
};
Button.propTypes = {
  text: _propTypes.default.string.isRequired,
  type: _propTypes.default.string,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  isLoading: _propTypes.default.bool
};
var _default = Button;
exports.default = _default;